import Banner from './Banner';
export type { BannerMessageType, BannerWidth } from './types';
export default Banner;
